import { styled } from "@mui/material/styles";

import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";

export const StyledTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
  "&.MuiTableSortLabel-root:hover, MuiTableSortLabel-root:focus": {
    color: theme.palette.grayScale.gray5,
  },
  "&.Mui-active": {
    color: theme.palette.grayScale.white,
  },
  "&.MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon ": {
    color: theme.palette.grayScale.white,
  },
}));

export const THeadCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.institutional.braskemGray,
    textTransform: "uppercase",
    color: theme.palette.grayScale.white,
    fontWeight: "bold",
    padding: theme.spacing(2),
  },
}));
